<template>
  <div class="login" style="height: 100%;"></div>
</template>

<script>
import weui from 'weui.js';
export default {
  name: 'error',
  components: {
  },
  data() {
    return {
      clients: [],
      profile: {},
    }
  },
  computed: {

  },
  beforeMount() {
  },

  mounted() {
    this.showErr()
  },

  methods: {
    showErr() {
      // now only one error type
      weui.alert(this.$t('tokenExpired'), {
        buttons: [{
          label: this.$t('ok'),
          onClick: function () {
            window.location.href = '/login'
          },
        }]
      })
      return
    },
  },

  watch: {

  }
}
</script>


<style lang="scss" scoped>
.weui-cells__group_form {
  .weui-label {
    max-width: 7em;
  }
  .weui-cell__hd {
    padding-right: 10px;
  }
  .weui-cell {
    padding: 16px;
  }
}
</style>